'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Modal.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Modal view component, does not manage its own state.
 */
var Modal = function Modal(_ref) {
  var size = _ref.size,
    children = _ref.children,
    visible = _ref.visible;
  var baseModalClass = (0, _classnames2.default)('c-modal', {
    'c-modal--small': size === 'small'
  }, {
    'c-modal--medium': size === 'medium'
  }, {
    'c-modal--fullscreen': size === 'fullscreen'
  }, {
    'c-modal--height-auto': size === 'height-auto'
  });
  var contextModalClass = (0, _classnames2.default)('c-modal-context', {
    'c-modal-context--visible': visible
  });
  return _react2.default.createElement('div', {
    className: contextModalClass
  }, _react2.default.createElement('div', {
    className: baseModalClass
  }, children));
};
Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Size of the modal*/
  size: _propTypes2.default.oneOf(['small', 'medium', 'fullscreen', 'height-auto']),
  /**Children of the modal*/
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = Modal;